import numeral from 'numeral'

export default function(inputRut) {
    
  if (inputRut.length < 3) {
    return inputRut
  }
  var numbers = inputRut.replace(/[^\dkK]/g, '')
  validate(numbers)
  var parts = numbers.split('')
  if (parts.length === 0) return numbers
  var last = parts.pop()
  if (parts.length === 0) return numbers
  var final = numeral(parts.join('')).format('0,0') + '-' + last
  final = final.replace(/,/g, '.')
  return final;

}

function validate(valor) {
  valor = valor.replace('-', '')
  let cuerpo = valor.slice(0, -1)
  let dv = valor.slice(-1).toUpperCase()
  if (cuerpo.length < 7) {
    return false
  }
  let suma = 0
  let multiplo = 2
  for (let i = 1; i <= cuerpo.length; i++) {
    let index = multiplo * valor.charAt(cuerpo.length - i)
    suma = suma + index
    if (multiplo < 7) {
      multiplo = multiplo + 1
    } else {
      multiplo = 2
    }
  }
  let dvEsperado = 11 - suma % 11
  dv = dv === 'K' ? 10 : dv
  dv = dv === 0 ? 11 : dv
  if (String(dvEsperado) !== String(dv)) {
    return false
  }
  return true
}



// WEBPACK FOOTER //
// ./src/App/helpers/validations/rutFormatter.js